<div class="m-4">
  @if (label()) {
    <div class="mb-1.5 flex items-center gap-1.5">
      <label class="text-sm font-medium text-gray-700">
        {{ label() }}

        @if (required()) {
          <span class="ml-1 text-red-500">*</span>
        }
      </label>
      @if (helpText()) {
        <div class="group relative">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="h-4 w-4 cursor-pointer ">
            <path
              d="M11 17H13V11H11V17ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM11 9H13V7H11V9Z" />
          </svg>
          <div
            class="pointer-events-none absolute bottom-full left-1/2 z-50 mb-2
                 hidden w-max max-w-xs -translate-x-1/2
                 rounded-md bg-slate-800 px-3 py-2
                 text-xs font-normal leading-5 text-white
                 shadow-lg group-hover:block">
            {{ helpText() }}
          </div>
        </div>
      }
    </div>
  }
  <div
    class="w-full rounded-lg border-2 border-dashed border-gray-300 p-4 transition hover:border-blue-400 hover:bg-blue-50 sm:p-5">
    @if (imagePreviews().length > 0) {
      <div class="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
        @for (image of imagePreviews(); track image.preview) {
          <div class="relative">
            <img
              [src]="image.preview"
              [alt]="image.file.name"
              class="h-40 w-full rounded-lg object-cover sm:h-48" />
            <button
              type="button"
              class="absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-full bg-black/60 text-sm text-white hover:bg-black/80"
              (click)="removeImage(image.id)">
              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" id="mdi-close" viewBox="0 0 24 24">
                <path
                  d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
              </svg>
            </button>
          </div>
        }
        <button
          type="button"
          class="flex h-40 w-full flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed border-gray-300 text-gray-500 transition hover:border-blue-400 hover:bg-blue-50 sm:h-48"
          (click)="openImageOptions()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-8 w-8">
            <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
          </svg>
          <span class="text-sm font-medium">Add more</span>
        </button>
      </div>
    } @else {
      <button
        type="button"
        class="flex min-h-32 w-full flex-col items-center justify-center gap-2 text-center text-gray-500 transition hover:bg-blue-50 sm:min-h-36"
        (click)="openImageOptions()">

        @if (allowCamera()) {
          <app-svg-icon [size]="32" [src]="'assets/icons/camera.svg'"></app-svg-icon>


          <span class="text-sm font-medium">Click to take picture</span>
          <span class="text-xs text-gray-400">Use your camera</span>
        } @else {

          <app-svg-icon [size]="32" [src]="'assets/icons/image.svg'"></app-svg-icon>
          <span class="text-sm font-medium">Add images</span>
          <span class="text-xs text-gray-400">PNG, JPG or WEBP</span>
        }
      </button>
    }
  </div>
  <input
    #fileInput
    type="file"
    accept="image/png,image/jpeg,image/webp"
    multiple
    hidden
    (change)="onImageSelected($event)"
  />
  @if (showImageOptions()) {
    <div
      class="fixed inset-0 z-50 flex items-end justify-center bg-black/40 p-4 sm:items-center"
      (click)="closeImageOptions()">
      <div class="w-full max-w-md rounded-2xl bg-white p-5 shadow-xl" (click)="$event.stopPropagation()">
        <div class="mb-5 text-center">
          <h3 class="text-lg font-semibold text-gray-900">Add images</h3>
          <p class="mt-1 text-sm text-gray-500">Choose how you want to add your images</p>
        </div>
        <div class="flex flex-col gap-2">
          <button
            type="button"
            class="flex w-full items-center gap-4 rounded-xl p-4 text-left transition hover:bg-gray-100 active:bg-gray-100"
            (click)="takePhoto()">
                    <span class="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blue-100 text-xl">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-6 w-6">
                            <path
                              d="M4,4H7L9,2H15L17,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9Z" />
                        </svg>
                    </span>
            <span>
                        <span class="block text-sm font-medium text-gray-900"> Take photo </span>
                        <span class="block text-xs text-gray-500"> Use your camera </span>
                    </span>
          </button>
          <button
            type="button"
            class="flex w-full items-center gap-4 rounded-xl p-4 text-left transition hover:bg-gray-100 active:bg-gray-100"
            (click)="chooseFromGallery()">
                    <span class="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gray-100 text-xl">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-6 w-6">
                            <path
                              d="M21 3H2V16H21V3M2 17H6V21H2V17M7 17H11V21H7V17M12 17H16V21H12V17M17 17H21V21H17V17Z"
                            />
                        </svg>
                    </span>
            <span>
                        <span class="block text-sm font-medium text-gray-900"> Choose from gallery </span>
                        <span class="block text-xs text-gray-500"> Select multiple images from your device </span>
                    </span>
          </button>
        </div>
        <button
          type="button"
          class="mt-3 w-full rounded-xl px-4 py-3 text-sm font-medium text-gray-500 hover:bg-gray-100"
          (click)="closeImageOptions()">
          Cancel
        </button>
      </div>
    </div>
  }
  @if (showCamera()) {
    <div class="fixed inset-0 z-[60] flex items-center justify-center bg-black p-4">
      <div class="flex w-full max-w-lg flex-col overflow-hidden rounded-2xl bg-black">
        <div class="flex items-center justify-between bg-white p-4">
          <h3 class="text-lg font-semibold text-gray-900">Take a photo</h3>
          <button
            type="button"
            class="flex h-9 w-9 items-center justify-center rounded-full text-gray-500 hover:bg-gray-100"
            (click)="closeCamera()"
          >
            ✕
          </button>
        </div>
        <video #video autoplay muted playsinline class="aspect-[4/3] w-full bg-black object-cover"></video>
        <div class="flex items-center justify-center gap-4 bg-white p-5">
          <button
            type="button"
            class="rounded-full bg-blue-600 px-6 py-3 text-sm font-semibold text-white hover:bg-blue-700 active:bg-blue-700"
            (click)="captureImage()"
          >
            Capture
          </button>
          <button
            type="button"
            class="rounded-full border border-gray-300 px-6 py-3 text-sm font-medium text-gray-700 hover:bg-gray-100"
            (click)="closeCamera()"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  }
  @if (showPermissionPopup()) {
    <div class="fixed inset-0 z-[70] flex items-center justify-center bg-black/50 p-4">
      <div class="w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl">
        <div class="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9 2h6l2 3h3c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-1-2-2V7c0-1.1.9-2 2-2h3l2-3zm3 6a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"
              fill="#dc2626"
            />
          </svg>
        </div>
        <h3 class="text-lg font-semibold text-gray-900">Camera access is blocked</h3>
        <p class="mt-2 text-sm leading-6 text-gray-600">
          Camera permission is required to take a photo. Please allow camera access in your browser settings and
          try again.
        </p>
        <button
          type="button"
          class="mt-5 w-full rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-blue-700"
          (click)="closePermissionPopup()">
          Okay
        </button>
      </div>
    </div>
  }
  @if (cameraError()) {
    <div class="mt-3 rounded-lg bg-red-50 p-3 text-sm text-red-600">{{ cameraError() }}</div>
  }
</div>
